import { useEffect, useState } from 'react';
import { markUpdateAccepted, subscribeToUpdate } from './updateSignal';
import './pwa.css';

/**
 * Global "hay una versión nueva" banner (brief "PWA instalable HAMMER",
 * requisito 3). `serviceWorkerRegistration.register()`'s `onUpdate` callback
 * (wired in `index.js`) reaches this component through `updateSignal.js`
 * instead of props, because that callback runs outside the React tree.
 * "Actualizar" marks the update as accepted (fix round 1: the ONLY signal
 * `reloadOnAcceptedUpdate` uses to tell an accepted update apart from
 * `clientsClaim()` firing `controllerchange` on a first install) and THEN
 * posts `SKIP_WAITING` to the waiting worker — the actual reload happens
 * once via the `controllerchange` listener wired in `index.js`, so this
 * component doesn't need to know when the new worker actually takes control.
 */
export function UpdateBanner({ subscribe = subscribeToUpdate, onAccept = markUpdateAccepted }) {
  const [registration, setRegistration] = useState(null);

  useEffect(() => subscribe(setRegistration), [subscribe]);

  if (!registration || !registration.waiting) return null;

  function handleUpdate() {
    onAccept();
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }

  return (
    <div className="gym-update-banner" role="status">
      <p className="gym-update-banner__text">Hay una versión nueva de HAMMER</p>
      <button type="button" className="gym-button gym-button--primary gym-update-banner__action" onClick={handleUpdate}>
        Actualizar
      </button>
    </div>
  );
}
